import cx from 'classnames';
import notificationStyle from '../common/notifications/NotificationsPanel.module.scss';
import { SkeletonUI } from './SkeletonLoaderUI';
import styles from './SkeletonLoaderUI.module.scss';

const NotificationsLoaderUI = ({ className, renderOne }) => {

  const cardHeight = 121
  let noOfCards = 1

  if(!renderOne) {
    const containerHeight = window.innerHeight - 280;
    noOfCards = Math.round(containerHeight / cardHeight)
  }

  const placeholders = Array.from(Array(noOfCards).keys()).map(a => {
    return (
      <div key={a} className={cx(className, notificationStyle.notificationCard, styles.notificationCard)}>
        <SkeletonUI count={2} />
        <SkeletonUI count={1} width={100} />
      </div>
  )})
    
  return placeholders
}

export default NotificationsLoaderUI